import {connectDynamic} from 'go/components/dynamic/dynamicComponent';
import {Loader, Segment, List, Form} from 'semantic-ui-react';
import React, {Component} from 'react';
import {Alert} from 'componentLibrary';
import {Checkbox} from 'app-ui-componentlibrary/dist/go/components/common/FormControls';
import {TextAreaFieldFrom as TextAreaField} from 'app-ui-componentlibrary';

import {DynamicReviewAttachments} from 'componentLibrary';
import {displayObjectErrors} from 'common/utils';
import {ALWAYS_DIRTY_MAP} from 'app-ui-componentlibrary/dist/common/constants';
import {produce} from 'immer';
import _ from 'lodash';

export class StatutoryRequirementsReviewPanel extends Component {
  state = {
    statutoryData: {},
  };

  componentDidMount() {
    if (!_.isEmpty(this.props.data)) {
      this.setState({statutoryData: this.props.data});
    }
  }

  componentDidUpdate(prevProps) {
    const ruleIds = _.map(this.props.statutoryData, (s) => s.ruleId);
    const filteredData = {};
    _.forEach(this.state.statutoryData, (d, ruleId) => {
      if (_.includes(ruleIds, ruleId)) {
        filteredData[ruleId] = d;
      }
    });

    // Check if statutoryData has been changed (from Rules)
    if (!_.isEqual(this.state.statutoryData, filteredData)) {
      this.setState({statutoryData: filteredData}, () => this.handleBlur());
    }

    // Check if context.awardRecommendation.payload.statutoryWaiver has been change (could be by config Reducer)
    if (!_.isEqual(this.props.data, prevProps.data)) {
      this.setState({statutoryData: this.props.data}, () => this.handleBlur());
    }
  }

  handleChange = (name, value, ruleId) => {
    const {statutoryData} = this.state;
    this.setState({
      statutoryData: produce(statutoryData, (draft) => {
        _.set(draft, [ruleId, name], value);
      }),
    });
  };

  handleBlur = (fieldName, ruleId) => {
    const {saveEntityData, validationId, entityType, entityDataPath} = this.props;
    const {statutoryData} = this.state;
    saveEntityData(
      entityDataPath,
      entityType,
      statutoryData,
      `${validationId}.${ruleId}.${fieldName}`
    );
  };

  renderGrantList(msg) {
    if (!_.isEmpty(msg.grantList)) {
      let grantList = msg.grantList;
      return (
        <React.Fragment>
          <br />
          <List as="ul">
            {grantList &&
              grantList.map((grant, i) => {
                return (
                  <List.Item as="li" key={i}>
                    {grant}
                  </List.Item>
                );
              })}
          </List>
        </React.Fragment>
      );
    }
  }

  renderToast = (popDescrepency) => {
    if (!_.isEmpty(popDescrepency[0])) {
      let msgObj = popDescrepency[0];

      return (
        <React.Fragment>
          <br />
          <Alert size="mini" header={msgObj.title} type="error" dismissable={false}>
            {msgObj.text}
            {this.renderGrantList(msgObj)}
          </Alert>
        </React.Fragment>
      );
    }
  };

  renderWaiverRequestCheckbox = (ruleId) => {
    const {entityDataPath} = this.props;

    const WAIVER_REQUESTED = 'waiverRequested';
    const waiverRequested = _.get(
      this.state.statutoryData,
      [ruleId, WAIVER_REQUESTED],
      false
    );

    return (
      <div id="waiver-request" className="margin-bottom--standard margin-top--standard">
        <Checkbox
          id={ruleId}
          checked={waiverRequested}
          label="Waiver requested"
          name={`${entityDataPath}.${ruleId}.waiverRequested`}
          handleBlur={() => this.handleBlur(WAIVER_REQUESTED, ruleId)}
          handleChange={() => {
            this.setState(
              {
                statutoryData: produce(this.state.statutoryData, (draft) => {
                  _.set(draft, [ruleId, WAIVER_REQUESTED], !waiverRequested);
                }),
              },
              () => {
                this.handleBlur(WAIVER_REQUESTED, ruleId);
              }
            );
          }}
        />
      </div>
    );
  };

  renderWaiverRequestfields = (ruleId) => {
    const {
      validationDirtyMap,
      validationErrors,
      entityDataPath,
      entityId,
      entityType,
      organizationId,
      programId,
    } = this.props;

    const firstValidationErrors = _.find(validationErrors, (er) => !er.isValid);

    const currValidationErrors = _.get(firstValidationErrors, ['error', ruleId]);
    const currDirtyMap = _.get(validationDirtyMap, ['dirty', ruleId]);
    const waiverRequestComment = _.get(
      this.state.statutoryData,
      [ruleId, 'waiverRequestComment'],
      ''
    );

    const displayErr = (fieldPath) => {
      return displayObjectErrors(currValidationErrors, currDirtyMap, fieldPath);
    };

    return (
      <div id="waiver-fields" className="margin-bottom--standard margin-top--standard">
        <TextAreaField
          title="Justification/Internal comments"
          label="Justification/Internal comments"
          name={`${entityDataPath}.${ruleId}.waiverRequestComment`}
          size="large"
          value={waiverRequestComment}
          maxLength={4000}
          handleChange={(e, {value}) => {
            this.handleChange('waiverRequestComment', value, ruleId);
          }}
          handleBlur={() => this.handleBlur('waiverRequestComment', ruleId)}
          displayError={displayErr('waiverRequestComment').displayError}
          errorMessages={displayErr('waiverRequestComment').errorMessages}
        />

        <div className="margin-top--standard">
          <DynamicReviewAttachments
            entityDataPath={`${entityDataPath}.${ruleId}.waiverRequestAttachment`}
            metaDataEntityType={entityType}
            entityType="grant"
            attachmentType={'Statutory Waiver Attachment ' + ruleId}
            guidance="Upload the recipient waiver request"
            uploaderOnly={true}
            displayFormat="panel"
            numAllowed={5}
            fileSizeLimit={25}
            entityId={entityId}
            organizationId={organizationId}
            programId={programId}
          />
        </div>

        <DynamicReviewAttachments
          entityDataPath={`${entityDataPath}.${ruleId}.waiverDeterminationAttachment`}
          metaDataEntityType={entityType}
          entityType="grant"
          attachmentType={'Waiver Determination Attachment ' + ruleId}
          guidance={`Upload the signed waiver determination ${
            this.props.optionalDetermination ? '(optional)' : ''
          }`}
          uploaderOnly={true}
          optional={true}
          displayFormat="panel"
          numAllowed={5}
          fileSizeLimit={25}
          entityId={entityId}
          organizationId={organizationId}
          programId={programId}
        />
      </div>
    );
  };

  renderStatuatoryPanel() {
    const {statutoryData} = this.props;

    let popDescrepList = statutoryData.filter(function (d) {
      return d.ruleId === 'popDescrep';
    });

    let msgList = statutoryData.filter(function (d) {
      return d.ruleId !== 'popDescrep';
    });

    return (
      <React.Fragment>
        {this.renderToast(popDescrepList)}
        The award recommendation violates these requirements:
        <br />
        <List as="ul">
          {_.map(msgList, (msg) => {
            const waiverData = _.get(this.state, ['statutoryData', msg.ruleId]);
            return (
              <List.Item as="li" key={msg.ruleId}>
                {msg.text}
                {this.renderGrantList(msg)}
                {msg.waiverable && (
                  <Form>
                    {this.renderWaiverRequestCheckbox(msg.ruleId)}
                    {_.get(waiverData, 'waiverRequested', false) &&
                      this.renderWaiverRequestfields(msg.ruleId)}
                  </Form>
                )}
              </List.Item>
            );
          })}
        </List>
      </React.Fragment>
    );
  }

  renderComponent() {
    return <React.Fragment>{this.renderStatuatoryPanel()}</React.Fragment>;
  }

  render() {
    if (this.props.statutoryData !== undefined) {
      return this.renderComponent();
    } else {
      return (
        <Segment vertical padded>
          <Loader active>Loading...</Loader>
        </Segment>
      );
    }
  }
}

export default connectDynamic(StatutoryRequirementsReviewPanel);
